import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createChannelFailed,
  createChannelRequested,
  createChannelSucceeded,
  deleteChannelFailed,
  deleteChannelRequested,
  deleteChannelSucceeded,
  updateChannelFailed,
  updateChannelRequested,
  updateChannelSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createChannelRequest(data) {
  yield put(createChannelRequested(data));

  try {
    const { item } = yield call(request, api.createChannel, data);

    const action = createChannelSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createChannelFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateChannelRequest(id, data) {
  yield put(updateChannelRequested(id, data));

  try {
    const { item } = yield call(request, api.updateChannel, id, data);

    const action = updateChannelSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateChannelFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteChannelRequest(id) {
  yield put(deleteChannelRequested(id));

  try {
    const { item } = yield call(request, api.deleteChannel, id);
    const action = deleteChannelSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteChannelFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
